/**
 * Runtime configuration sourced from `import.meta.env`. All values must be
 * `VITE_*` prefixed for Vite to inline them at build time. Missing values
 * fall back to safe dev defaults so the bundle still boots locally.
 */
export interface AppEnv {
  readonly tenantId: string;
  readonly clientId: string;
  readonly apiScope: string;
  readonly redirectUri: string;
  readonly apiBaseUrl: string;
  /** Phase 14: when true, the web UI runs in local-mode (same-origin API,
   * MSAL auth bypassed, stub bearer token). Set via `VITE_LOCAL_MODE=true`
   * at build time when bundling for `@wt-codegraph/local`. */
  readonly localMode: boolean;
}

function read(key: string, fallback = ''): string {
  const v = (import.meta.env as Record<string, string | undefined>)[key];
  return typeof v === 'string' && v.length > 0 ? v : fallback;
}

export function loadEnv(): AppEnv {
  const localMode = read('VITE_LOCAL_MODE', '') === 'true';
  return {
    tenantId: read('VITE_AZURE_TENANT_ID', 'common'),
    clientId: read('VITE_AZURE_CLIENT_ID'),
    apiScope: read('VITE_AZURE_API_SCOPE', 'api://wt-codegraph/.default'),
    redirectUri: read('VITE_MSAL_REDIRECT_URI', window.location.origin),
    // Local mode: same-origin so requests hit the bundled `@wt-codegraph/local`
    // HTTP server (typically `http://127.0.0.1:9876`).
    apiBaseUrl: localMode
      ? read('VITE_API_BASE_URL', window.location.origin)
      : read('VITE_API_BASE_URL', 'http://localhost:8080'),
    localMode,
  };
}

export const ENV: AppEnv = loadEnv();
